module.exports = {
      id: "ac9a9c5944038ae91418d548455d8502electricity-230v.svg-usage",
      viewBox: "0 0 417 417",
      url: __webpack_public_path__ + "sprite.svg#ac9a9c5944038ae91418d548455d8502electricity-230v.svg",
      toString: function () {
        return this.url;
      }
    }